
import { defineComponent, computed, ref } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'UILightbox',
  components: {
    VueEasyLightbox: () => import('vue-easy-lightbox'),
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: true,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    const lightbox = ref();
    const currentImageIdx = computed(() => lightbox?.value?.imgIndex);

    return {
      lightbox,
      currentImageIdx,
    };
  },
});
